import { h } from 'preact';

import MoviePageFooter from 'components/editor/movies/movieFooter';
import WatchPageEditor from 'components/editor/movies/watch/watch';

// Styling imports will only happen in the final styling file used (i.e. homeEntFocus.sss or showtimesFocus.sss)
// import s from 'components/editor/movies/watch/watchFocus.sss';

export default class FocusWatchPageEditor extends WatchPageEditor {
	s = {}; // Styling will only be assigned in the final implementation (i.e. homeEntFocus.js or showtimesFocus.js)

	renderFooter() {
		// Footer needs to be half page for Focus Features
		return (
			<MoviePageFooter {...this.props} halfPage />
		);
	}

	renderTopLinks() {
		return null; // Focus Features doesn't have top links
	}

	renderMediaSettings() {
		return [
			this.renderOnesheetSettings(),
		];
	}
}
